import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { InfoFormLabel, SelectPlaceholder } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';

const LegalRelationshipField = () => {
  const dispatch = useAppDispatch();
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.LEGAL_RELATIONSHIP });
  const { control, watch } = useFormContext();
  const fieldValue = watch('legal_relationship_tag');
  const { hasLockedStatus } = useHasLockedStatus();

  useEffect(() => {
    if (fieldValue === 'Public_DataSet') {
      dispatch(
        openModal({
          type: ModalTypesEnum.CONFIRM,
          payload: {
            showActionControl: false,
            title: 'Set Legal Relationship',
            description: 'Setting the Legal Relationship to ‘Public’ will route the dataset to Atlan for awareness.',
          },
        }),
      );
    }
  }, [fieldValue]);

  return (
    <FormControlLabel
      label={
        <InfoFormLabel
          label="LEGAL RELATIONSHIP"
          tooltipText="Please select under what legal relationship the dataset was collected."
        />
      }
      required
      control={
        <Controller
          name="legal_relationship_tag"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message as string}</FormHelperText>
              <Select
                {...field}
                error={!!fieldState.error}
                disabled={hasLockedStatus || isFetching}
                renderValue={() => {
                  if (!field.value) return <SelectPlaceholder>Select the legal relationship</SelectPlaceholder>;

                  return data?.find(({ key }) => key === field.value)?.value;
                }}
              >
                {data?.map(({ value, key }) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default LegalRelationshipField;
